import PortalLearningPath from '@classes/LearningPath'
import PortalLearningPathUnit from '@classes/LearningPathUnit'
import { LP_STATUS } from '@utils/constants/learningPath'
import React, { useEffect } from 'react'
import Button from './Button'
import RightSlider from './RightSlider'
import { SessionPanelWrapper } from './style'

interface IPSessionPanel {
  Path: PortalLearningPath
}

const SessionPanel: React.FC<IPSessionPanel> = ({ Path }) => {
  const [isOpen, setOpen] = React.useState(false)
  const [status, setStatus] = React.useState<string | undefined>()
  const [unit, setUnit] = React.useState<PortalLearningPathUnit>()
  const [path, setPath] = React.useState<PortalLearningPath>()

  const toggleButton = (val?: boolean) => {
    setOpen(val || !isOpen)
  }

  useEffect(() => {
    const pristinePath = Path.pristineClone()
    const nextSession = Path.NextSessionUnit
    pristinePath.UnlimitedLCSOverride = Path.UnlimitedCoaching
    const Unit = pristinePath.NextSessionUnit
    const isOngoing = Number(Unit?.StudentSessions?.OngoingLPSession?.lesson?.UnitId) === Unit?.Id
    const stat =
      nextSession?.UnlimitedLCS && (!Unit?.IsBooked || !isOngoing)
        ? LP_STATUS.UNLOCKED
        : Number(Unit?.Session?.lesson?.UnitId || 0) === Unit?.Id && !Unit?.Session?.Materials?.length && isOngoing
          ? LP_STATUS.CUSTOM_BOOKED
          : Unit?.Status
    setStatus(stat)
    setUnit(Unit)
    setPath(pristinePath)
  }, [])

  return !Path.FlexUnits.length || !status ? null : (
    <SessionPanelWrapper>
      <Button
        onClickHandler={() => unit && toggleButton()}
        status={status}
        booked={unit?.IsBooked}
        isOpen={isOpen}
        isActive={Path.IsActiveFlexRegistration}
      />
      <RightSlider isOpen={isOpen} onCloseHandler={toggleButton} Path={path || Path} MainPath={Path} />
    </SessionPanelWrapper>
  )
}

export default SessionPanel
